import {LOG_OUT, LOGIN, RESTORE, SET_ERROR, SET_LOADING, SET_USER, SIGN_UP, AUTH, CHECKED_AUTH} from "./types";

// export function login({data, successCB=()=>{}, errorCB=()=>{}, finallyCB=()=>{}}) {
//     return (dispatch, getState) => {
//         dispatch(setFetchingProfile(true));
//         loginFetch(data)
//             .then((data)=>{
//                 successCB();
//                 setUser(data);
//             })
//             .catch(()=>{
//                 dispatch(setErrorProfile(true));
//                 errorCB();
//             })
//             .finally(()=>{
//                 dispatch(setFetchingProfile(false));
//                 finallyCB();
//             });
//     };
// }
//
// export function signUp({data, successCB=()=>{}, errorCB=()=>{}, finallyCB=()=>{}}) {
//     return (dispatch, getState) => {
//         dispatch(setFetchingProfile(true));
//         signUpFetch(data)
//             .then(successCB)
//             .catch(()=>{
//                 dispatch(setErrorProfile(true));
//                 errorCB();
//             })
//             .finally(()=>{
//                 dispatch(setFetchingProfile(false));
//                 finallyCB();
//             });
//     };
// }
//
// export function restorePassword({data, successCB=()=>{}, errorCB=()=>{}, finallyCB=()=>{}}) {
//     return (dispatch, getState) => {
//         dispatch(setFetchingProfile(true));
//         restorePasswordFetch(data)
//             .then(successCB)
//             .catch(()=>{
//                 dispatch(setErrorProfile(true));
//                 errorCB();
//             })
//             .finally(()=>{
//                 dispatch(setFetchingProfile(false));
//                 finallyCB();
//             });
//     };
// }

export function login(payload) {
    return {
        type: LOGIN,
        payload,
    };
}

export function signUp(payload) {
    return {
        type: SIGN_UP,
        payload,
    };
}

export function restorePassword(payload) {
    return {
        type: RESTORE,
        payload,
    };
}

export function setFetchingProfile(isFetching) {
    return {
        type: SET_LOADING,
        isFetching,
    };
}

export function setErrorProfile(isError) {
    return {
        type: SET_ERROR,
        isError,
    };
}

export function setUser(user) {
    return {
        type: SET_USER,
        user,
    };
}

export function logOut() {
    return {
        type: LOG_OUT,
    };
}

export function checkedAuth() {
    return {
        type: CHECKED_AUTH,
    }
}

export function auth() {
    return {
        type: AUTH,
    };
}

